import md5 from 'crypto-js/md5';

function getGravatarUrl(email: string): string {
  const trimmedEmail = email.trim().toLowerCase();
  const hash = md5(trimmedEmail).toString();
  return `https://www.gravatar.com/avatar/${hash}?d=mp`;
}

export default getGravatarUrl;
